<script lang="ts">
  import DashboardLayout from '../DashboardLayout.svelte';
  import DashHero from '../shared/DashHero.svelte';
  import KardexQueueWidget from '../widgets/KardexQueueWidget.svelte';
  import QuickActions from '../widgets/QuickActions.svelte';
  import { Hospital } from '../../../lib/api';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  let kardexPend = $state(0);

  async function cargar() {
    const all = await Hospital.kardexPendientes().catch(() => []);
    kardexPend = all.length;
  }

  const actions = [
    { id: 'kardex', label: 'Kárdex', icon: '' },
    { id: 'farmaciaPos', label: 'POS farmacia', icon: '' },
    { id: 'farmacia', label: 'Catálogo', icon: '' },
  ];

  $effect(() => { cargar(); const t = setInterval(cargar, 45000); return () => clearInterval(t); });
</script>

<DashboardLayout title="Dispensación" subtitle="Kárdex hospitalario y punto de venta" variant="farmacia">
  <DashHero emoji='' title="Farmacia hospitalaria" subtitle="Administraciones programadas y dispensación" variant="farmacia" />
  <QuickActions {actions} onAction={onNavigate} />

  <div class="dash-kpis">
    <div class="dash-kpi"><div class="dash-kpi-label">Dosis pendientes</div><div class="dash-kpi-value">{kardexPend}</div></div>
  </div>

  <div class="dash-grid">
    <div class="col-12"><KardexQueueWidget limit={15} interactive /></div>
  </div>
</DashboardLayout>
